import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldWrapperComponent } from './mat-form-field-wrapper.component';
import { MatFormFieldModule } from '@angular/material/form-field';



@NgModule({
  declarations: [MatFormFieldWrapperComponent],
  imports: [
    CommonModule,
    MatFormFieldModule
  ],
  exports: [MatFormFieldWrapperComponent]
})
export class MatFormFieldWrapperModule { }
